import api from './api';

export const quotesService = {
  // Get all quotes
  getAll: async () => {
    const response = await api.get('/quotes');
    return response.data;
  },

  // Get single quote
  getById: async (id) => {
    const response = await api.get(`/quotes/${id}`);
    return response.data;
  },

  // Create new quote
  create: async (quoteData) => {
    const response = await api.post('/quotes', quoteData);
    return response.data;
  },

  // Update quote
  update: async (id, quoteData) => {
    const response = await api.put(`/quotes/${id}`, quoteData);
    return response.data;
  },

  // Delete quote
  delete: async (id) => {
    const response = await api.delete(`/quotes/${id}`);
    return response.data;
  },

  // Send quote to client
  send: async (id, emailData) => {
    const response = await api.post(`/quotes/${id}/send`, emailData);
    return response.data;
  },

  // Convert quote to itinerary
  convertToItinerary: async (quoteId) => {
    const response = await api.post(`/itineraries/convert-quote/${quoteId}`);
    return response.data;
  }
};
